export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-leads-list.vue?vue&type=template&id=616862c4&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-leads-list/lk-leads-list.vue?vue&type=template&id=616862c4&
// module id = 1154
// module chunks = 0